<div class="dialog-container">
  <h1 mat-dialog-title class="title">
    Return for Career Matches
  </h1>

  <mat-dialog-content>
    <p class="description">
      Assessments from Futurenav™ Edge open in a new window. 
      When done, come back to this tab to continue.
    </p>
    <div class="image-container">
      <img 
        src="/assets/images/results/edge-assessment.png"
        alt="new window"
      />
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="buttons">
      <button
        mat-flat-button
        mat-dialog-close
        type="button"
        class="btn btn-subdued"
      >
        Back
      </button>

      <a
        href="{{ data.assessmentUrl }}"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button
          mat-flat-button
          mat-dialog-close
          type="button"
          class="btn btn-primary btn-align"
          (click)="onStartAssessment()"
        >
          <span class="btn-text">Start Assessment</span>
          <span class="open-in-new-icon">
            <img 
              src="/assets/icons/results/new-window.svg"
              alt="new window"
            />
          </span>
        </button>
      </a>
    </div>
  </mat-dialog-actions>
</div>
